import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Global } from 'constants/global.const';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from 'services/auth.service';
import { USE_AUTH } from './tokens';

export const refreshTokenInterceptor: HttpInterceptorFn = (req, next) => {
	if (!req.context.get(USE_AUTH)) return next(req);

	const authService = inject(AuthService);

	if (req.url.includes(Global.services.user.refreshtoken())) {
		return next(req);
	}

	if (authService.hasInvalidAccess()) {
		authService.logout();
		return throwError(() => new HttpErrorResponse({ status: 401 }));
	}

	if (authService.needsRefresh()) {
		return authService.handleRefresh(req, next);
	}

	return next(req).pipe(
		catchError((error) => {
			if (error instanceof HttpErrorResponse && error.status === 401) {
				return authService.handleRefresh(req, next);
			}

			return throwError(() => error);
		}),
	);
};
